import { render, staticRenderFns } from "./FormChangeReasonOutput.vue?vue&type=template&id=51acfb74&"
import script from "./FormChangeReasonOutput.vue?vue&type=script&lang=js&"
export * from "./FormChangeReasonOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports